// ContextWrapper.js
import React from 'react';
import { useFilters } from '../utils/FilterContext';
import { useSearch } from '../utils/SearchContext';
import Navbar from '../components/ui/mainScreen/navbar'; // подставьте правильный путь

function ContextWrapper() {
    const filterContextValue = useFilters();
    const searchContextValue = useSearch();

    // Подсчитываем количество активных фильтров
    const activeFiltersCount = Object.entries(filterContextValue.activeFilters)
        // исключаем "panorama"
        .filter(([category, isActive]) => category !== 'panorama' && isActive)
        .length;
}

export default ContextWrapper;